import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceBase } from '../service-base/ServiceBase';
import { environment } from './../../../environments/environment';

@Injectable()
export class FiltroService
  extends ServiceBase {
  private baseUrlService: string;

  constructor(
    http: HttpClient,
    router: Router
  ) {
    super(http, router);
    this.baseUrlService = environment.URL_API
  }

  filtro = '';
  dealer = '';

  protected getURL(): string {
    return `${this.baseUrlService}/filtro/` + this.filtro;
  }

  public buscar(filtro: string): Promise<any> {
    this.filtro = filtro;
    return this.get([]);
  }

  protected getURLDealer(): string {
    return `${this.baseUrlService}/` + this.dealer;
  }

  public buscarDealer(filtro: string): Promise<any> {
    this.filtro = filtro;
    return this.get([]);
  }

}
